/**
* 共通ヘルパー
*/
import axios from '@/plugins/axios';

const actions = {
  /** ロケーションからenvを判別 */
  checkEnv({ commit, state }) {
    if (state.env.flag) return;

    const hostname = location.hostname;
    let env;
    switch (hostname) {
      case 'localhost':
        env = 'local';
        break;
      case 'dev.kiryutimes.jp':
        env = 'develop';
        break;
      case 'kiryutimes.jp':
        env = 'production';
        break;
      default:
        env = 'production';
        break;
    }

    const data = {
      flag: true,
      name: env,
    };

    commit('putEnv', data);
  },

  checkSystemMaster({ commit, rootState }) {
    const systemMasters = [
      'imauji@cicac.jp',
      'sonoda@cicac.jp',
      'fujikawa@cicac.jp',
      'yamaguchi@cicac.jp',
      'amagawa@cicac.jp',
      'iguchi@cicac.jp',
    ];
    const flag = systemMasters.includes(rootState.user.email);
    commit('isSystemMaster', flag);
  },

  reset({ commit }) {
    commit('reset');
  },

  /** backend共通マスターデータ */
  getMaster({ commit, dispatch }) {
    axios({
      method: 'GET',
      url: '/v1/helper/get/master',
    })
      .then((response) => {
        commit('putMaster', response.data.master);
        dispatch('getSubscriptionData', response.data.master);
      })
      .catch((error) => {
        if (error.response) console.log(error.response.data);
        else console.log(error);
      });
  },

  getSubscriptionData({ commit, state }, data) {
    const env = state.env.name;

    const params = {
      subscription_id: data.products.product_id[env],
    };

    axios({
      method: 'GET',
      url: 'v1/stripe/subscription/get/detail',
      params,
    })
      .then((response) => {
        const res = response.data;
        const priceData = {
          web: null,
          webPaper: null,
          paper: null,
        };
        res.prices.data.forEach((price) => {
          priceData[price.nickname] = price;
        });
        commit('putPrices', priceData);
      })
      .catch((error) => {
        if (error.response) console.log(error.response.data);
        else console.log(error);
      })
      .finally(() => {
      });
  },

};


const mutations = {
  putEnv(state, data) {
    state.env.flag = data.flag;
    state.env.name = data.name;
  },

  isSystemMaster(state, bool) {
    state.isSystemMaster = bool;
  },

  systemMasters(state, array) {
    state.systemMasters = array;
  },

  reset(state) {
    state.systemMasters = [];
    state.isSystemMaster = false;
    state.env = {
      name: 'production',
      flag: false,
    };
  },

  putMaster(state, data) {
    state.master = data;
  },

  putPrices(state, data) {
    state.prices = data;
  },
};


const state = {
  isSystemMaster: false,
  env: {
    name: null,
    flag: false,
  },
  master: {},
  prices: {},
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
};
